export default __webpack_public_path__ + "static/Sales-cbbb60211ff36ac8dc3b18b4786d083b.svg";